var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerificationsSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#FFD700",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(2,2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,1c-34.7,0 -63,28.3 -63,63c0,34.7 28.3,63 63,63c34.7,0 63,-28.3 63,-63c0,-34.7 -28.3,-63 -63,-63zM64,7c31.4,0 57,25.6 57,57c0,31.4 -25.6,57 -57,57c-31.4,0 -57,-25.6 -57,-57c0,-31.4 25.6,-57 57,-57zM93.77539,38c-0.775,0.05 -1.52617,0.4 -2.07617,1l-27.89844,32.59961l-12.70117,-12.69922c-1.2,-1.2 -3.09922,-1.2 -4.19922,0c-1.2,1.2 -1.2,3.09922 0,4.19922l15,15c0.6,0.6 1.29961,0.90039 2.09961,0.90039h0.09961c0.8,0 1.60117,-0.4 2.20117,-1l30,-35c1.1,-1.3 0.89922,-3.19922 -0.30078,-4.19922c-0.65,-0.6 -1.44961,-0.85078 -2.22461,-0.80078z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationsSuccess);
export default __webpack_public_path__ + "static/media/verifications-success.70315df01eaf41e38ffb588df549d829.svg";
export { ForwardRef as ReactComponent };